
/* tslint:disable */
/* eslint-disable */
/**
 * Search API
 * Search
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {FetchOptions} from 'ofetch';
import type {
  MicroConsultingProfilesResponse,
  ValidationError,
} from '../models';
import {
    MicroConsultingProfilesResponseFromJSON,
    MicroConsultingProfilesResponseToJSON,
    ValidationErrorFromJSON,
    ValidationErrorToJSON,
} from '../models';

export interface SearchMicroConsultingProfilesRequest {
    p?: number;
    q?: string;
    category?: Array<string>;
    businessSector?: Array<string>;
}

/**
 * 
 */
export class MicroConsultingSearchApi extends runtime.BaseAPI {

    /**
     * Search freelance profiles with an active micro-consulting offer
          */
    async searchMicroConsultingProfilesRaw(requestParameters: SearchMicroConsultingProfilesRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<MicroConsultingProfilesResponse>> {
        const queryParameters: any = {};

        if (requestParameters['p'] != null) {
            queryParameters['p'] = requestParameters['p'];
        }

        if (requestParameters['q'] != null) {
            queryParameters['q'] = requestParameters['q'];
        }

        if (requestParameters['category'] != null) {
            queryParameters['category'] = requestParameters['category'];
        }

        if (requestParameters['businessSector'] != null) {
            queryParameters['businessSector'] = requestParameters['businessSector'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request<MicroConsultingProfilesResponse>({
            path: `/search/api/profiles/micro-consulting`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (response._data) { response._data=MicroConsultingProfilesResponseFromJSON(response._data); }
        return response;
    }

    /**
     * Search freelance profiles with an active micro-consulting offer
          */
    async searchMicroConsultingProfiles(requestParameters: SearchMicroConsultingProfilesRequest = {}, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<MicroConsultingProfilesResponse> {
        const response = await this.searchMicroConsultingProfilesRaw(requestParameters, initOverrides);
        return response._data;
    }

}
